<template>
  <YdDialog
    ref="couponCreate"
    title="创建优惠券"
    :visible.sync="visible"
    :append-to-body="true"
    width="70%"
  >
    <el-form
      ref="form"
      :model="form"
      size="small"
      :inline="false"
      :rules="rules"
      label-width="130px"
    >
      <el-form-item label="优惠券名称：" prop="couponName">
        <el-input
          v-model="form.couponName"
          placeholder="请输入优惠券名称"
          clearable
          maxlength="10"
          show-word-limit
          style="width: 24vw"
        />
      </el-form-item>

      <el-form-item label="数量：" prop="couponNum">
        <avue-input-number
          v-model="form.couponNum"
          placeholder="优惠券数量"
          style="width: 12vw"
          minRows="1"
        />
        张
      </el-form-item>
      <el-form-item label="抵扣类型：" required>
        <div style="margin-top: 14px">
          <el-radio v-model="form.type" label="1" border>代金</el-radio>
          <span>
            立减
            <avue-input-number
              minRows="0"
              precision="2"
              v-model="form.discountsMoney"
              style="width: 8vw"
              :disabled="form.type !== '1'"
            />
            元
          </span>
        </div>

        <div style="margin-top: 14px">
          <el-radio v-model="form.type" label="2" border>满减</el-radio>
          <span>
            满
            <avue-input-number
              minRows="0"
              precision="2"
              v-model="form.fullMoney"
              style="width: 8vw"
              :disabled="form.type !== '2'"
            />
            元 减
            <avue-input-number
              minRows="0"
              precision="2"
              v-model="form.discountsMoney"
              style="width: 8vw"
              :disabled="form.type !== '2'"
            />
            元
          </span>
        </div>

        <div style="margin-top: 14px">
          <el-radio v-model="form.type" label="3" border>折扣</el-radio>
          <span>
            <avue-input-number
              v-model="form.discount"
              style="width: 8vw"
              precision="1"
              minRows="1"
              maxRows="10"
              :disabled="form.type !== '3'"
            />
            折 最高优惠
            <avue-input-number
              minRows="0"
              precision="2"
              v-model="form.discountsMoney"
              style="width: 8vw"
              :disabled="form.type !== '3'"
            />
            元
          </span>
        </div>
      </el-form-item>

      <el-form-item label="有效期：" required>
        <div style="margin-top: 14px">
          <el-radio v-model="form.dateType" label="1">固定日期</el-radio>
          <div>
            <el-date-picker
              v-model="dates"
              type="datetimerange"
              prop="datetimerange"
              format="yyyy-MM-dd HH:mm:ss"
              valueFormat="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :disabled="form.dateType !== '1'"
              :picker-options="pickerOptions"
              @change="handelDates"
            />
          </div>
        </div>

        <div style="margin-top: 14px">
          <el-radio v-model="form.dateType" label="2">动态日期</el-radio>
          <span>
            领取后
            <el-input
              v-model="form.expipyDate"
              style="width: 6vw"
              :disabled="form.dateType !== '2'"
            />
            天内有效
          </span>
        </div>
      </el-form-item>

      <el-form-item label="可用日期：" v-if="effectiveDateArr.length > 0">
        <el-radio-group v-model="availableDateType" size="mini" @input="availableDateTypChange">
          <el-radio label="0">所有日期可用</el-radio>
          <el-radio label="1">部分日期可用</el-radio>
        </el-radio-group>
        <span v-if="availableDateType === '1'" class="color-redFont margin-left-20">
          注：不可用日期：以行程出发时间计
        </span>
        <el-card v-if="availableDateType === '1'" style="padding-left: 138px">
          <div style="padding: 15px 20px">
            <div>
              <el-checkbox
                v-model="unavailableDate[0].check"
                :disabled="holidayConfigTip !== ''"
                style="margin-right: 54px"
              >
                节假日不可用
              </el-checkbox>
              <span style="color: #f56c6c">{{ holidayConfigTip }}</span>
            </div>
            <div
              v-if="holidayUnavailableDate.length > 0 && unavailableDate[0].check"
              style="margin-top: 10px"
            >
              <el-tag
                v-for="tag in holidayUnavailableDate"
                :key="tag"
                style="margin-right: 5px; margin-bottom: 5px"
              >
                {{ tag }}
              </el-tag>
            </div>
            <div>
              <el-checkbox
                v-model="unavailableDate[1].check"
                @change="unavailableDateChange(unavailableDate[1].check, 1)"
                style="margin-right: 40px"
              >
                重复不可用日期
              </el-checkbox>
              <el-select
                v-if="unavailableDate[1].check"
                style="width: 420px; margin-top: 12px"
                v-model="unavailableDate[1].weekArr"
                clearable
                multiple
                placeholder="请选择重复不可用日期"
              >
                <el-option
                  v-for="item in weekOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
            <div
              v-if="repeatUnavailableDate.length > 0 && unavailableDate[1].check"
              style="margin-top: 10px"
            >
              <el-tag
                v-for="tag in repeatUnavailableDate"
                :key="tag"
                style="margin-right: 5px; margin-bottom: 5px"
              >
                {{ tag }}
              </el-tag>
            </div>
            <div>
              <el-checkbox
                v-model="unavailableDate[2].check"
                @change="unavailableDateChange(unavailableDate[2].check, 2)"
                style="margin-right: 26px"
              >
                自定义不可用日期
              </el-checkbox>
              <el-date-picker
                v-if="unavailableDate[2].check"
                style="width: 420px; margin-top: 12px"
                type="dates"
                value-format="yyyy-MM-dd"
                v-model="unavailableDate[2].day"
                placeholder="选择不可用日期"
              />
            </div>
            <div
              v-if="
                unavailableDate[2].check &&
                this.unavailableDate[2].day &&
                unavailableDate[2].day.length > 0
              "
              style="margin-top: 10px"
            >
              <el-tag
                v-for="tag in unavailableDate[2].day"
                :key="tag"
                closable
                style="margin-right: 5px; margin-bottom: 5px"
                @close="handleTagClose(tag)"
              >
                {{ tag }}
              </el-tag>
            </div>
          </div>
        </el-card>
      </el-form-item>

      <!--判断批次是供应商-->
      <el-form-item label="使用范围：" v-if="info.merchantId !== '0'" required>
        <div style="margin-top: 14px">
          <span>
            可用业务
            <avue-select v-model="form.bu" :dic="[{ label: '定制客运', value: 1 }]" />
          </span>
        </div>
        <div style="margin-top: 14px">
          <span>
            可用线路
            <avue-select
              v-model="selectLine"
              all
              multiple
              :dic="lineDic"
              :props="{ label: 'lineName', value: 'lineId' }"
              :disabled="allLine === '1'"
              @change="handleSelectLine"
              placeholder="请选择"
            />
            <span style="padding-left: 10px">
              <el-checkbox
                v-model="allLine"
                true-label="1"
                false-label="0"
                @change="handleCheckLine1"
              >
                全部
              </el-checkbox>
            </span>
          </span>
          <div style="padding-left: 48px" v-if="allLine === '1'">
            <el-card class="box-card">
              <div>
                <block v-for="(item, index) of lineDic" :key="index">
                  <span style="margin: 6px">
                    <el-checkbox v-model="item.check" true-label="1" false-label="2" border>
                      {{ item.lineName }}
                    </el-checkbox>
                  </span>
                </block>
              </div>
            </el-card>
          </div>
        </div>
      </el-form-item>

      <!--判断批次是平台-->
      <el-form-item label="使用范围：" v-if="info.merchantId === '0'">
        <div style="margin-top: 14px">
          <span>
            可用业务
            <avue-select
              v-model="form.bu"
              :dic="[
                { label: '定制客运', value: 1 },
                { label: '定点接送', value: 2 }
              ]"
            />
          </span>
        </div>
        <div style="margin-top: 14px">
          <span>
            可用供应商
            <span style="padding-left: 8px">
              <el-button
                type="primary"
                size="mini"
                :disabled="allMerchant === '1'"
                @click.stop="handleMerchant"
              >
                添加
              </el-button>
            </span>
          </span>
          <span style="padding-left: 10px">
            <el-checkbox
              v-model="allMerchant"
              true-label="1"
              false-label="2"
              @change="handleEnabledChecked"
            >
              全选
            </el-checkbox>
          </span>
          <div v-if="allMerchant === '2'">
            <block v-for="(item, index) of merchantLists" :key="item.merchantId">
              <div class="acea-row row-middle">
                <i class="el-icon-remove-outline" @click="remove(index)"></i>
                <span class="mr5">{{ item.merchantName }}</span>
              </div>
              <div style="padding-left: 48px">
                <el-card class="box-card">
                  <div style="padding: 8px">
                    <block v-for="(citem, index) of item.line" :key="index">
                      <span style="margin: 6px">
                        <el-checkbox v-model="citem.check" true-label="1" false-label="2" border>
                          {{ citem.lineName }}
                        </el-checkbox>
                      </span>
                    </block>
                  </div>
                </el-card>
              </div>
            </block>
          </div>
        </div>
        <div style="margin-top: 14px" v-if="allMerchant === '1'">
          <span>
            不可用供应商
            <span style="padding-left: 8px">
              <el-button type="primary" size="mini" @click.stop="handleMerchant">添加</el-button>
            </span>
          </span>
          <block v-for="(item, index) of merchantLists" :key="item.merchantId">
            <div class="acea-row row-middle">
              <i class="el-icon-remove-outline" @click="remove(index)"></i>
              <span class="mr5">{{ item.merchantName }}</span>
            </div>
          </block>
        </div>
      </el-form-item>
      <el-form-item label="扫码补票是否可用:">
        <el-switch v-model="form.driverUser" />
      </el-form-item>

      <el-form-item label="优惠券承担方:" prop="responsible">
        <el-radio-group v-model="form.responsible">
          <el-radio :label="1">三方共补</el-radio>
          <el-radio :label="2">平台独补</el-radio>
          <el-radio :label="3">平台供应商双方共补</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" type="danger" @click="visible = false">取 消</el-button>
      <el-button type="primary" size="small" @click="submit" :loading="loading">保 存</el-button>
    </div>
    <select-merchant ref="merchant" v-if="selectMerchantVisible" @submit="getMerchantLists" />
  </YdDialog>
</template>

<script>
  import { getLineByMerchant, addCoupon, getHolidayConfig } from '@/api/marketing/coupon-api'
  import selectMerchant from '@/components/select-merchant/select-merchant'
  import dayjs from 'dayjs'
  import { isEmpty } from 'lodash-es'
  export default {
    name: 'couponPkgAdd',
    components: {
      selectMerchant
    },
    data() {
      return {
        loading: false,
        visible: false,
        selectMerchantVisible: false,
        lines: [],
        checkLine1: [],
        dates: [],
        form: {
          type: '1',
          dateType: '1',
          isAll: '0',
          isAllMerchant: '2',
          bu: 1,
          driverUser: true,
          disableDate: [] // 禁用日期，默认为空，代表所有日期可用
        },
        unavailableDate: [
          {
            type: 1,
            check: false,
            day: []
          },
          {
            type: 2,
            check: false,
            weekArr: [],
            day: []
          },
          {
            type: 2,
            check: false,
            day: []
          }
        ], // 不可用日期   空数组 表示所有日期可用
        availableDateType: '0', // 可用日期类型
        weekOptions: [
          { value: 1, label: '周一' },
          { value: 2, label: '周二' },
          { value: 3, label: '周三' },
          { value: 4, label: '周四' },
          { value: 5, label: '周五' },
          { value: 6, label: '周六' },
          { value: 0, label: '周日' }
        ],
        holidayArr: [], // 节假日
        pickerOptions: {
          disabledDate: (time) => {
            const startDate = new Date().getTime() - 8.64e7
            return startDate > time.getTime()
          }
        },
        allLine: '2',
        allMerchant: '2',
        selectLine: [],
        info: {},
        batchInfo: {},
        lineDic: [],
        merchantDic: [],
        merchantLists: [],
        rules: {
          couponName: [{ required: true, message: '优惠券名称不能为空', trigger: 'blur' }],
          couponNum: [{ required: true, message: '优惠券数量不能为空', trigger: 'blur' }],
          responsible: [{ required: true, message: '优惠券承担方不能为空', trigger: 'change' }]
        }
      }
    },
    computed: {
      // merchantLists: {
      //   get () { return this.$store.state.coupon.merchantLines },
      //   set (val) { this.$store.commit('UPDATE_MERCHANT_COUPON', val) }
      // },
      // 不可用日期范围
      effectiveDateArr() {
        if (this.form.dateType === '1' && this.dates && this.dates.length === 2) {
          // 固定日期
          return this.dates
        }
        if (this.form.dateType === '2') {
          // 动态日期 取批次有效期
          return this.batchInfo.validDate ? this.batchInfo.validDate.split('至') : []
        }
        return []
      },
      // 后台是否配置节假日
      holidayConfigTip() {
        if (this.effectiveDateArr.length === 0) {
          return ''
        }
        if (this.holidayArr.length === 0) {
          return '请联系管理员配置节假日数据'
        }
        const sYear = dayjs(this.effectiveDateArr[0]).year()
        const sObj = this.holidayArr.find((item) => dayjs(item).year() === sYear)
        if (!sObj) {
          return `请联系管理员配置${sYear}年节假日数据`
        }
        const eYear = dayjs(this.effectiveDateArr[1]).year()
        const eObj = this.holidayArr.find((item) => dayjs(item).year() === eYear)
        if (!eObj) {
          return `请联系管理员配置${eYear}年节假日数据`
        }
        return ''
      },
      // 节假日不可用日期
      holidayUnavailableDate() {
        return this.getHolidayDate(this.effectiveDateArr, this.holidayArr)
      },
      // 重复不可用日期
      repeatUnavailableDate() {
        return this.getWeekDate(this.effectiveDateArr, this.unavailableDate[1].weekArr)
      }
    },
    created() {
      // 获取节假日配置信息
      getHolidayConfig().then((res) => {
        const { code, data } = res
        if (code !== 0 || !Array.isArray(data)) {
          return
        }
        this.holidayArr = data.map((item) => {
          return item.day
        })
      })
    },
    watch: {
      visible(val) {
        if (!val) this.selectLine = []
      }
    },
    methods: {
      init(row, batchInfo) {
        this.visible = true
        this.info = row
        this.batchInfo = batchInfo
        this.reset()
        this.$nextTick(() => {
          this.$refs.form && this.$refs.form.clearValidate()
          // 通过供应商查询线路
          if (this.info.merchantId !== '0') {
            getLineByMerchant(row.merchantId).then((resp) => {
              this.lineDic = resp.data
            })
          }
        })
      },
      // 初始化可用日期相关数据
      initDisableDate() {
        this.availableDateType = '0'
        this.unavailableDate = [
          {
            type: 1,
            check: false,
            day: []
          },
          {
            type: 2,
            check: false,
            weekArr: [],
            day: []
          },
          {
            type: 2,
            check: false,
            day: []
          }
        ]
      },
      reset() {
        this.dates = []
        this.allMerchant = '2'
        this.allLine = '2'
        this.merchantLists = []
        this.form = {
          type: '1',
          dateType: '1',
          isAll: '0',
          isAllMerchant: '2',
          bu: 1,
          driverUser: true,
          disableDate: []
        }
        this.initDisableDate()
      },
      // 计算节假日不可用日期
      getHolidayDate(dateArr, holidayArr) {
        if (dateArr.length !== 2 || holidayArr.length === 0) {
          return []
        }
        const sDate = dateArr[0].split(' ')
        const eDate = dateArr[1].split(' ')
        const sTime = dayjs(sDate[0]).valueOf()
        const eTime = dayjs(eDate[0]).valueOf()
        const relArr = []
        for (let k = sTime; k <= eTime; ) {
          const dateStr = dayjs(k).format('YYYY-MM-DD')
          if (holidayArr.includes(dateStr)) {
            relArr.push(dateStr)
          }
          k = k + 24 * 60 * 60 * 1000
        }
        return relArr
      },
      // 计算重复不可用日期
      getWeekDate(dateArr, weekArr) {
        if (dateArr.length !== 2 || weekArr.length === 0) {
          return []
        }
        const sDate = dateArr[0].split(' ')
        const eDate = dateArr[1].split(' ')
        const sTime = dayjs(sDate[0]).valueOf()
        const eTime = dayjs(eDate[0]).valueOf()
        const relArr = []
        for (let k = sTime; k <= eTime; ) {
          if (weekArr.includes(dayjs(k).day())) {
            relArr.push(dayjs(k).format('YYYY-MM-DD'))
          }
          k = k + 24 * 60 * 60 * 1000
        }
        return relArr
      },
      submit() {
        this.$refs.form.validate((valid) => {
          if (!valid) {
            this.$message.error('请填写所有必填项数据')
            return
          }
          const { type, discountsMoney, fullMoney, discount, bu } = this.form
          // 抵扣类型校验
          if (
            (type === '1' && !discountsMoney) ||
            (type === '2' && (!fullMoney || !discountsMoney)) ||
            (type === '3' && (!discount || !discountsMoney))
          ) {
            this.$message.error('请选择并填写完整抵扣类型')
            return
          }
          // 校验不可用日期
          if (this.form.dateType === '1') {
            if (isEmpty(this.dates)) {
              this.$message.error('请选择固定日期')
              return
            }
          }
          if (this.form.dateType === '2') {
            if (isEmpty(this.form.expipyDate)) {
              this.$message.error('请输入动态日期')
              return
            }
          }
          if (this.availableDateType === '1') {
            if (
              !this.unavailableDate[0].check &&
              !this.unavailableDate[1].check &&
              !this.unavailableDate[2].check
            ) {
              this.$message.error('请选择不可用日期')
              return
            }
            if (this.unavailableDate[1].check && this.unavailableDate[1].weekArr.length === 0) {
              this.$message.error('请选择重复不可用日期')
              return
            }
            if (
              this.unavailableDate[2].check &&
              this.unavailableDate[2].day &&
              this.unavailableDate[2].day.length === 0
            ) {
              this.$message.error('请选择自定义不可用日期')
              return
            }

            this.unavailableDate[0].day = this.unavailableDate[0].check
              ? [...this.holidayUnavailableDate]
              : []
            this.unavailableDate[1].day = this.unavailableDate[1].check
              ? [...this.repeatUnavailableDate]
              : []
            this.form.disableDate = JSON.parse(JSON.stringify(this.unavailableDate))
          } else {
            this.form.disableDate = []
          }
          // 校验使用范围
          if (!bu) {
            this.$message.error('请选择可用业务')
            return
          }
          if (this.info.merchantId !== '0' && !this.selectLine.length && this.allLine !== '1') {
            this.$message.error('请选择可用线路')
            return
          }
          if (
            this.info.merchantId === '0' &&
            !this.merchantLists.length &&
            this.allMerchant !== '1'
          ) {
            this.$message.error('请选择可用供应商')
            return
          }

          if (this.allLine === '1') {
            const index = this.lineDic.findIndex((item) => item.check === '2')
            if (index !== -1) {
              this.form.isAll = '0'
              const list = this.lineDic.filter((item) => item.check === '1')
              this.form.useLine = list.map((item) => {
                return item.lineId
              })
            } else {
              this.form.isAll = '1'
            }
          } else {
            this.form.isAll = '0'
            this.form.useLine = this.selectLine
          }
          if (this.allMerchant === '1') {
            if (this.merchantLists && this.merchantLists.length > 0) {
              this.form.unusableMerchantList = this.merchantLists.map((item) => {
                return item.merchantId
              })
              this.form.isAllMerchant = '2'
            } else {
              this.form.isAllMerchant = '1'
            }
          } else {
            this.form.merchantLines = this.merchantLists
          }
          this.form.giftId = this.info.giftId
          this.form.batchId = this.info.batchId

          this.loading = true
          addCoupon(this.form)
            .then((resp) => {
              if (resp.code === 0) {
                this.visible = false
                this.$message.success('操作成功')
                this.$emit('refreshDetailsList')
              }
            })
            .finally(() => {
              this.loading = false
            })
        })
      },
      handelDates(val) {
        if (val && val.length === 2) {
          this.form.startIndate = val[0]
          this.form.endIndate = val[1]
        } else {
          this.form.startIndate = ''
          this.form.endIndate = ''
          this.initDisableDate()
        }
      },
      handleSelectLine(val) {
        this.selectLine = val
      },
      // 是否全选供应商
      handleEnabledChecked(val) {
        if (val === '1') {
          this.merchantLists = []
          this.form.merchantId = ''
        }
      },
      // 是否全选线路
      handleCheckLine1(val) {
        if (val === '1') {
          this.form.isAll = '1'
          this.form.useLine = []
        }
        if (val === '0') {
          this.form.isAll = '0'
        }
      },
      handleMerchant() {
        this.selectMerchantVisible = true
        this.$nextTick(() => {
          this.$refs.merchant.init()
        })
      },
      getMerchantLists(merchantLists) {
        this.merchantLists = merchantLists
      },
      remove(index) {
        this.merchantLists.splice(index, 1)
      },
      handleTagClose(tag) {
        this.unavailableDate[2].day = this.unavailableDate[2].day
          ? this.unavailableDate[2].day.filter((item) => item !== tag)
          : []
      },
      // 可用日期类型值改变事件
      availableDateTypChange() {
        this.unavailableDate = [
          {
            type: 1,
            check: false,
            day: []
          },
          {
            type: 2,
            check: false,
            weekArr: [],
            day: []
          },
          {
            type: 2,
            check: false,
            day: []
          }
        ]
      },
      // 自定义不可用日期值改变事件
      unavailableDateChange(val, index) {
        if (index === 1) {
          this.unavailableDate[index].weekArr = []
        }
        this.unavailableDate[index].day = []
      }
    }
  }
</script>

<style lang="scss" scoped>
  .acea-row {
    display: flex;
    flex-wrap: wrap;
  }

  .acea-row.row-middle {
    align-items: center;
    padding-left: 50px;
    padding-top: 12px;
  }
  .mr5 {
    padding-left: 8px;
  }

  .box-card {
    width: 600px;
    padding: 5px;
    max-height: 250px;
    overflow: auto;
  }
  ::v-deep .el-card__body {
    padding: 0;
    border-radius: 4px;
    border: 1px solid #ebeef5;
    background-color: #fff;
    overflow: hidden;
    color: #303133;
    transition: 0.3s;
  }
</style>
